import {
  ANALYTICS_COLOR_1,
  ANALYTICS_COLOR_2,
  ANALYTICS_COLOR_3,
  ANALYTICS_COLOR_POSTS,
  ANALYTICS_COLOR_YELLOW
} from '../../../config/constants';
import {
  METRIC_GMB_LOCAL_POST_VIEWS_SEARCH,
  METRIC_GMB_LOCATION_AVERAGE_RATING,
  METRIC_GMB_LOCATION_RATING_COUNT,
  METRIC_GOOGLE_GMB_ACTIONS_DRIVING_DIRECTIONS,
  METRIC_GOOGLE_GMB_ACTIONS_PHONE,
  METRIC_GOOGLE_GMB_ACTIONS_WEBSITE,
  METRIC_GOOGLE_GMB_VIEWS_MAPS,
  METRIC_GOOGLE_GMB_VIEWS_SEARCH
} from '../../../config/metrics';
import { displayFunctions } from '../../../utils/chartsUtils';
import {
  DEMO_DATA_GOOGLE_CLICKS_DIRECTIONS,
  DEMO_DATA_GOOGLE_CLICKS_TOTAL,
  DEMO_DATA_GOOGLE_CLICKS_WEBSITE,
  DEMO_DATA_GOOGLE_REACH_MAPS,
  DEMO_DATA_GOOGLE_REACH_SEARCH,
  DEMO_DATA_GOOGLE_REACH_TOTAL
} from '../../../utils/demoDataUtils/demoDataArrays';
import { getStaticDataPoints } from '../../../utils/demoDataUtils/demoDataFunctions';

const filters = {
  filters: []
};

export const ReachConfig: any = {
  shouldBeCached: false,
  ...filters,

  metrics: [
    {
      metrics: [METRIC_GOOGLE_GMB_VIEWS_MAPS],
      title: 'google_maps',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      display: 'sum',

      platform: 'google',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_GOOGLE_REACH_MAPS
        }
      }
    },

    {
      metrics: [METRIC_GOOGLE_GMB_VIEWS_SEARCH],
      title: 'google_search',
      iconCssClass: 'optional value',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      display: 'sum',

      platform: 'google',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_GOOGLE_REACH_SEARCH
        }
      }
    },
    {
      metrics: [METRIC_GOOGLE_GMB_VIEWS_SEARCH, METRIC_GOOGLE_GMB_VIEWS_MAPS],
      title: 'total',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_YELLOW,
      type: 'line',
      display: 'sum',
      platform: 'google',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_GOOGLE_REACH_TOTAL
        }
      }
    }
  ]
};

export const clicksConfig: any = {
  shouldBeCached: false,
  ...filters,

  metrics: [
    {
      metrics: [METRIC_GOOGLE_GMB_ACTIONS_WEBSITE],
      title: 'website',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      display: 'sum',
      platform: 'google',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_GOOGLE_CLICKS_WEBSITE
        }
      }
    },

    {
      metrics: [METRIC_GOOGLE_GMB_ACTIONS_PHONE],
      title: 'phone',
      iconCssClass: 'optional value',
      hexColor: ANALYTICS_COLOR_2,
      type: 'line',
      display: 'sum',
      platform: 'google'
    },
    {
      metrics: [METRIC_GOOGLE_GMB_ACTIONS_DRIVING_DIRECTIONS],
      title: 'directions',
      iconCssClass: 'optional value',
      hexColor: ANALYTICS_COLOR_3,
      type: 'line',
      display: 'sum',

      platform: 'google',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_GOOGLE_CLICKS_DIRECTIONS
        }
      }
    },
    {
      metrics: [
        METRIC_GOOGLE_GMB_ACTIONS_DRIVING_DIRECTIONS,
        METRIC_GOOGLE_GMB_ACTIONS_WEBSITE,
        METRIC_GOOGLE_GMB_ACTIONS_PHONE,
        METRIC_GOOGLE_GMB_ACTIONS_DRIVING_DIRECTIONS
      ],
      title: 'total',
      iconCssClass: 'optional value',
      hexColor: ANALYTICS_COLOR_YELLOW,
      type: 'bar',
      display: 'sum',

      platform: 'google',
      demo_data_config: {
        func: getStaticDataPoints,
        kwargs: {
          data: DEMO_DATA_GOOGLE_CLICKS_TOTAL
        }
      }
    }
  ]
};

export const reviewConfig = {
  shouldBeCached: false,
  ...filters,

  metrics: [
    {
      metrics: [METRIC_GMB_LOCATION_AVERAGE_RATING],
      title: 'star_rating',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line',
      platform: 'google'
    },
    {
      metrics: [METRIC_GMB_LOCATION_RATING_COUNT],
      title: 'Total',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_YELLOW,
      type: 'bar'
    }
  ]
};

export const postConfig = {
  shouldBeCached: false,
  ...filters,

  metrics: [
    {
      metrics: [METRIC_GMB_LOCAL_POST_VIEWS_SEARCH],
      title: 'google_search',
      iconCssClass: 'fas fab-facebook',
      hexColor: ANALYTICS_COLOR_1,
      type: 'line'
    }
  ]
};

// -------------------------------------------------------------------
export const businessProfileInteractions = {
  addAdditionalPlots: false,

  business_profile_interactions: {
    title: 'mixedChart.business_profile_interactions',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const impressionsDesktop = {
  addAdditionalPlots: true,

  maps: {
    title: 'mixedChart.impressions_desktop_maps',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  },
  search: {
    title: 'mixedChart.impressions_desktop_search',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const impressionsMobile = {
  addAdditionalPlots: true,

  maps: {
    title: 'mixedChart.impressions_mobile_maps',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  },
  search: {
    title: 'mixedChart.impressions_mobile_search',
    hexColor: ANALYTICS_COLOR_2,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const calls = {
  addAdditionalPlots: false,

  calls: {
    title: 'mixedChart.calls',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const messages = {
  addAdditionalPlots: false,

  messages: {
    title: 'mixedChart.messages',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const bookings = {
  addAdditionalPlots: false,

  bookings: {
    title: 'mixedChart.bookings',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const directions = {
  addAdditionalPlots: false,

  directions: {
    title: 'mixedChart.directions',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const websiteClicks = {
  addAdditionalPlots: false,

  website_clicks: {
    title: 'mixedChart.website_clicks',
    hexColor: ANALYTICS_COLOR_1,
    type: 'line',

    display: displayFunctions.sum
  }
};

export const newConfigsMap: any = {
  business_profile_interactions: businessProfileInteractions,
  impressions_desktop: impressionsDesktop,
  impressions_mobile: impressionsMobile,
  calls,
  messages,
  bookings,
  directions,
  website_clicks: websiteClicks,
  posts_per_day: {
    normalizeValues: true,
    title: 'mixedChart.posts_per_day',
    hexColor: ANALYTICS_COLOR_POSTS,
    type: 'bar',
    display: displayFunctions.sum,
    additionalPlot: true
  }
};
